export const TIME_PATTERN = 'MM:SS';
export const TIME_PATTERN_WITH_MS = 'MM:SS.SS';
export const FULL_TIME_PATTERN_WITH_MS = 'HH:MM:SS.SS';
export const TIME_PATTERN_SS = 'SS.SS';
export const TIME_PATTERN_SSS = 'SS.SSS';
export const TIME_PATTERN_HHMM = 'HH:MM';
export const TIME_PATTERN_HHMMSS = 'HH:MM:SS';
export const INCOMING_PATTERN = 'HH:MM:SS.SSS';
